import Spacer from '@berlitz/spacer'
import Lock2 from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/11-Lock-Unlock/Lock2'
import InformationCircle from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/14-Alerts/InformationCircle'
import PortalLearningPathUnit from '@classes/LearningPathUnit'
import { Card, CardContent, CardHeader, Icon, IconCircle, Subtitle, Title } from '@components/LPCard/Common'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TopTag } from '../Lesson/style'
import { Description, SubContainer } from './style'

export const Locked: React.FC<{ Unit?: PortalLearningPathUnit }> = ({ Unit }) => (
  <Card type="speakingPanel" active={true}>
    <CardContent isElective={Unit?.IsFromElective}>
      <CardHeader>
        {Unit?.IsFromElective && (
          <TopTag color="info100">
            <FormattedMessage id="Elective" defaultMessage="Elective" />
          </TopTag>
        )}
        <Icon color="white">
          <IconCircle color="info100" />
          <Lock2 />
        </Icon>
      </CardHeader>

      <Spacer size="md" />

      <Title color="info100">
        <FormattedMessage id="Live coaching session locked" />
      </Title>

      <Spacer size="sm" />

      <SubContainer>
        <Subtitle color="text00">
          <FormattedMessage id="Complete lessons to unlock live coaching sessions." />
        </Subtitle>
      </SubContainer>

      <Spacer size="md" />

      <SubContainer color="info30">
        <InformationCircle />
        <Description color="text00">
          <FormattedMessage id="Practice what you've learnt with an instructor, online via video. (approx. 30 minutes)" />
        </Description>
      </SubContainer>
    </CardContent>
  </Card>
)

export default Locked
